import React, { useCallback } from "react";

import { Avatar, Stack, Tooltip, Typography } from "@mui/material";
import { useSelectedBookmarkSelector } from "store";
import { IBookmark, UserLight } from "store/types";

import { getInitials } from "./bookmark-page";
import { getBookmarkPage } from "./bookmark-page";
import { useApplyBookmark } from "./use-apply-bookmark";

interface Props {
  bookmark: IBookmark;
  owner?: UserLight;
  onApplied: () => void;
}

export const SharedRow: React.FC<Props> = ({ bookmark, owner, onApplied }) => {
  const applyBookmark = useApplyBookmark();
  const selectedId = useSelectedBookmarkSelector();
  const page = getBookmarkPage(bookmark);
  const isActive = selectedId === bookmark.id;

  const handleClick = useCallback(() => {
    applyBookmark(bookmark);
    onApplied();
  }, [applyBookmark, bookmark, onApplied]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        padding: "8px 16px",
        cursor: "pointer",
        backgroundColor: isActive ? "#dbe8f5" : "transparent",
        "&:hover": { backgroundColor: isActive ? "#dbe8f5" : "#ecf1f8" }
      }}
      onClick={handleClick}
    >
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            color: isActive ? "primary.main" : "#071f35",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: 1.2
          }}
        >
          {bookmark.name}
        </Typography>
        <Typography sx={{ fontSize: "11px", color: "#5e7a95", lineHeight: 1.2 }}>{page.label}</Typography>
      </Stack>
      <Tooltip title={`Shared by ${owner?.full_name ?? "teammate"}`} placement="left" arrow enterDelay={400}>
        <Avatar
          sx={{ width: 22, height: 22, fontSize: 10, ml: "8px", flexShrink: 0 }}
          src={owner?.profile_photo_url || undefined}
          imgProps={{ decoding: "async" }}
        >
          {getInitials(owner?.full_name)}
        </Avatar>
      </Tooltip>
    </Stack>
  );
};
